<template>
  <div class="alert alert-warning d-flex justify-content-between" role="alert">
    <span><strong>Atenção: </strong><span v-html="message" /></span>
    <InfoIcon />
  </div>
</template>

<script>

import { InfoIcon } from 'vue-feather-icons'

export default {
  name: 'AlertBanner',
  components: {InfoIcon},
  props: {
    message: {
      type: String,
      required: true
    },
  },
}

</script>

<style scoped>
.alert-warning {
  background-color: var(--alert-warning-bg) !important;
  border-color: var(--alert-warning-border) !important;
  color: var(--alert-warning-text) !important;
}

.alert-warning * {
  color: var(--alert-warning-text) !important;
}

.alert-warning span {
  color: var(--alert-warning-text) !important;
}

.alert-warning strong {
  color: var(--alert-warning-text) !important;
}

.alert-warning ::v-deep * {
  color: var(--alert-warning-text) !important;
}

.alert-warning ::v-deep span {
  color: var(--alert-warning-text) !important;
}

.alert-warning ::v-deep a {
  color: var(--primary-color) !important;
  text-decoration: underline;
  font-weight: 600;
}

.alert-warning ::v-deep a:hover {
  color: var(--primary-color-hover) !important;
}

.alert-warning svg {
  color: var(--alert-warning-text) !important;
}
</style>